<template>
  <eventi-list-component :titoloEvento="titoloEvento" :utente="utente" :key="keyListaEventi" :pathEventResource="pathEventResource" :linkEvent="linkEvent" :gruppo="gruppo" :tipoEvento="tipoEvento"></eventi-list-component>
</template>
<script>
import UtilityMixin from "../../../../../utility/UtilityMixin";
import EventiListComponent from "../../../base/components/EventiListComponent.vue";
import EventiMixin from "../../../utility/mixins/EventiMixins";
export default {
  mixins: [UtilityMixin, EventiMixin],
  components: { EventiListComponent },
  props: {
    utente: {
      type: Object,
      default: function () {
        return { gruppo: { menuGruppo: [] } };
      },
    },
  },
  data() {
    return {
      showModalLoading: false,
      titoloEvento: "Visita Dermatologica",
      linkEvent: "/paziente/dermatologia/visitadermatologica",
      pathEventResource: "/dermavisite",
      keyListaEventi: 0,
      gruppo: "DERMATOLOGIA",
      tipoEvento: "VISTA DERMATOLOGICA",
    };
  },
  mounted() {
    let me = this;
    me.id = this.$route.params.id;
  },
  computed: {
    idPaziente() {
      return this.$route.query.idPaziente;
    },
    rows() {
      return this.items.length;
    },
    linkPatient() {
      return EventiMixin.getLinkPatient(this.utente, this.idPaziente);
    },
  },
  methods: {},
};
</script>
